import { render, staticRenderFns } from "./EmployeeTeam.vue?vue&type=template&id=6bbd41b2&"
import script from "./EmployeeTeam.vue?vue&type=script&lang=js&"
export * from "./EmployeeTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports